// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"ScommesseFallback_skeleton__qN6iO","noMargin":"ScommesseFallback_noMargin__Gxayc"};